export const merchantListConstants = {
	RESET_MERCHANT_INFO_STATE: "RESET_MERCHANT_INFO_STATE",
};
